import ExcelJS from "exceljs";

const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export async function downloadRowsAsXlsx({ filename, sheetName = "Report", title, subtitleRows = [], headers, rows, totalRow }) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Ebek One";
  const sheet = workbook.addWorksheet(String(sheetName).slice(0, 31), { views: [{ state: "normal" }] });
  const width = Math.max(headers?.length || 1, ...rows.map(row => row.length), totalRow?.length || 0);
  if (title) sheet.addRow([title]);
  subtitleRows.filter(Boolean).forEach(text => sheet.addRow([text]));
  if (title || subtitleRows.length) sheet.addRow([]);
  const headerRow = sheet.addRow(headers);
  headerRow.eachCell(cell => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF0F766E" } };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
  });
  rows.forEach(row => sheet.addRow(row));
  if (totalRow) {
    sheet.addRow([]);
    const row = sheet.addRow(totalRow);
    row.font = { bold: true };
  }
  sheet.columns = Array.from({ length: width }, (_, col) => {
    const values = [headers?.[col], ...rows.slice(0, 200).map(row => row[col]), totalRow?.[col]];
    const maxLength = values.reduce((max, value) => Math.max(max, String(value ?? "").length), 0);
    return { width: Math.min(42, Math.max(12, maxLength + 2)) };
  });
  const headerNumber = headerRow.number;
  sheet.views = [{ state: "frozen", ySplit: headerNumber, activeCell: `A${headerNumber + 1}` }];
  sheet.autoFilter = { from: { row: headerNumber, column: 1 }, to: { row: headerNumber, column: headers.length } };
  sheet.eachRow((row, rowNumber) => {
    if (rowNumber > headerNumber) row.alignment = { vertical: "top", wrapText: true };
  });
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: XLSX_MIME });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = String(filename).replace(/\.(csv|xls)$/i, ".xlsx");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
